import React from "react";

function FeaturesSection() {
  return (
    <div className="cards-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-image green">
                <i className="fas fa-code"></i>
              </div>
              <div className="card-body">
                <h5 className="card-title">Match Algorithm</h5>
              </div>
            </div>
            <div className="card">
              <div className="card-image red">
                <i className="fas fa-cog"></i>
              </div>
              <div className="card-body">
                <h5 className="card-title">Tasks Settings</h5>
              </div>
            </div>
            <div className="card">
              <div className="card-image yellow">
                <i className="fas fa-users"></i>
              </div>
              <div className="card-body">
                <h5 className="card-title">Social Interaction</h5>
              </div>
            </div>

            <div className="card">
              <div className="card-image blue">
                <i className="fas fa-comments"></i>
              </div>
              <div className="card-body">
                <h5 className="card-title">1v1 messaging</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturesSection;
